import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const alcohol = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
